import React, { Component } from "react";
import Navbar from "@/modules/Navbar";
import FixedBtn from "@succ/components/FixedBtn";
import Banner from "@succ/components/Banner";
import Countdown from "@/modules/Countdown";
import Tutors from "@succ/components/Tutors";
import Prizes from "@succ/components/Prizes";
import ScrollButton from "@succ/components/ScrollButton";
// import Theme from "@succ/components/Theme";
import About from "@succ/components/About";
import Timeline from "@/modules/Timeline";
import Faq from "@succ/components/Faq";
import Contact from "@/modules/Contact";
import Footer from "@/modules/Footer";
import Application from '@/modules/Application';
import SwiperPartners from '@/modules/SwiperPartners';
import Message from '@succ/message/message_ph'
import Translator from '@/modules/translator';
import { $t } from '@/modules/i18n';
import "@succ/views/PhApp.scss";

const collectionId = 330;

class App extends Component {
  constructor(props) {
    super(props);
    this.url = "https://careers.shopee.ph/succ/";
    this.imageURL = "https://careers.shopee.ph/succ/images/ph-cover.png";
    this.state = {
      message: Message(),
    }
    this.fixButtonWrapper = React.createRef()
    this.fixButtonRect = {}
  }

  getHelmetScript() {
    const message = this.state.message.application;

    return [{
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "Event",
        name: 'Shopee Philippines Ultimate Case Challenge 2022',
        description: message.desc,
        image: this.imageURL,
        startDate: message.startDate,
        endDate: message.endDate,
        url: this.url,
        audience: {
          audienceType: "Undergraduates (aged 18 and above) based in the Philippines."
        },
        location: {
          "@type": "Place",
          name: "Shopee Philippines",
          address: "Online",
        }
      })
    }]
  }

  calcCountDownInfo() {
    console.log(this.fixButtonWrapper);
    if (!this.fixButtonWrapper) {
      return
    }
    const rect = this.fixButtonWrapper.current.getBoundingClientRect()
    this.fixButtonRect = rect
    console.log(rect);
  }

  componentDidMount() {
    this.calcCountDownInfo();
  }

  render() {
    let Message = this.state.message;
    const script = this.getHelmetScript();
    return (
      <div className="App PH">
        <Application message={Message.application} url={this.url} imageURL={this.imageURL} script={script} viewport={false} />
        <Navbar message={Message.navbar} />
        <ScrollButton scrollStepInPx="150" delayInMs="0.66" />
        <FixedBtn showTop={this.fixButtonRect.top}>
          <a className="btn-sigh-up" href={Message.sighUpBtn.sighUpLink} target="_blank" rel="noopener noreferrer">{$t(Message.sighUpBtn.btnText)}</a>
        </FixedBtn>
        <Banner message={Message.banner} isPH={true} />
        <div ref={this.fixButtonWrapper}></div>
        <About message={Message.about} />
        <div className="timeline">
          <Timeline message={Message.timeline} />
        </div>
        <section id="prizes" className="prizes-wrapper">
          <Prizes className="prizes" message={Message.prizes} />
        </section>
        <Faq message={Message.faqs} />
        <SwiperPartners micrositeId={9}/>
        <div className="contact-wrapper">
          <span className="contact-deco-left"></span>
          <Contact message={Message.contact} />
          <span className="contact-deco-right"></span>
        </div>
        <Footer message={Message.footer} />
      </div>
    );
  }
}

export default Translator(App, Message, {}, { collectionId });
